import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import UserIcon from "../assets/profile.png";
import { Link } from "react-router-dom";
import { removeKey } from "../helpers/sessionKey";

export default function Logout() {
  const handleLogout = () => {
    removeKey("token");
    window.location.replace("/auth-login")
  };
  return (
    <div className="text-right">
      <Menu as="div" className="relative inline-block text-left z-50">
        <div>
          <Menu.Button className="inline-flex w-full justify-center rounded-md px-4 py-2 text-sm font-medium text-white hover:bg-opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
            <img src={UserIcon} alt="User Icon" className="cursor-pointer h-14 w-14" />
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute right-0 mt-2 w-32 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            <div className="px-1 py-1 z-[50]">
              <Menu.Item>
                <Link
                  to="/profile"
                  className=" text-black flex w-full items-center px-2 py-2 text-sm cursor-pointer"
                >
                  Profile
                </Link>
              </Menu.Item>
              <Menu.Item>
                <button
                  onClick={handleLogout}
                  className=" text-black flex w-full items-center px-2 py-2 text-sm cursor-pointer"
                >
                  Logout
                </button>
              </Menu.Item>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
}
